import { useCallback, useEffect, useState } from "react";
import { teammatesApi } from "../api";
import type { Teammate } from "../types/teammates";

const UPDATED_EVENT = "teammates-updated";

export function notifyTeammatesUpdated() {
  window.dispatchEvent(new CustomEvent(UPDATED_EVENT));
}

export function useTeammates(enabled: boolean) {
  const [teammates, setTeammates] = useState<Teammate[]>([]);
  const [loading, setLoading] = useState(enabled);

  const reload = useCallback(() => {
    if (!enabled) return;
    teammatesApi
      .list()
      .then((res) => setTeammates(Array.isArray(res.data) ? res.data : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [enabled]);

  useEffect(() => {
    reload();
  }, [reload]);

  useEffect(() => {
    if (!enabled) return;
    window.addEventListener(UPDATED_EVENT, reload);
    window.addEventListener("conversation-updated", reload);
    return () => {
      window.removeEventListener(UPDATED_EVENT, reload);
      window.removeEventListener("conversation-updated", reload);
    };
  }, [enabled, reload]);

  return { teammates, loading, reload };
}
